import axios from "axios";
import {
  AUTH_TOKEN_KEY,
  QUICK_SESSION_TOKEN_KEY,
} from "../utils/authSession";

const client = axios.create({
  baseURL:
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_API_URL ||
    "https://techiohisab.com/api",
});

client.defaults.withCredentials = true;

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default client;
